export default "__VITE_ASSET__r29fIoosfGbGvimn5vx2pA__"